module.exports = __webpack_public_path__ + "static/media/GIO.80c65c14.png";